<template>
    <div>
        <video ref="videoElement" crossorigin="anonymous" muted
            playsinline="true" class="input_video flip" :class="{ 'd-none': !debuging }"></video>
        <canvas v-if="!hideCanvas" ref="canvasElement" class="output_canvas flip"></canvas>
        <div v-if="debuging">Log: {{ log }}</div>
    </div>
</template>

<script>
import { addScript } from '@/utils/common.js'

export default {
    props: {
        'hideCanvas':{
            default: false,
        },
    },
    data(){
        return{
            faceMesh: null,
            canvasCtx: null,
            isLoading: true,
            videoTracks: [],
            log: [],
            debuging: false,
        }
    },
    methods:{
        onResults(results){
            this.canvasCtx.save();
            this.canvasCtx.clearRect(0, 0, this.$refs.canvasElement.width, this.$refs.canvasElement.height);
            this.canvasCtx.drawImage(results.image, 0, 0, this.$refs.canvasElement.width, this.$refs.canvasElement.height);
            this.canvasCtx.restore();

            this.$emit('results', results)
        },
        stopCam(){
            delete this.faceMesh;
            this.videoTracks.forEach(function(track) {
                track.stop();
            });
        }
    },
    async created(){
        await addScript('https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/face_mesh.js')

        try{
            this.faceMesh = new FaceMesh({locateFile: (file) => {
                return `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`;
            }});
            this.faceMesh.setOptions({
                maxNumFaces: 1,
                minDetectionConfidence: 0.4,
                minTrackingConfidence: 0.4,
            });
            this.faceMesh.onResults(this.onResults);
        } catch(e){
            console.log(e)
            this.log.push('create error')
            this.log.push(e)
        }
    },
    async mounted(){
        await addScript('/js/cam-util.js')
        
        try{
            this.$refs.canvasElement.width = window.innerWidth;
            this.$refs.canvasElement.height = window.innerHeight;
            this.canvasCtx = this.$refs.canvasElement.getContext('2d');

            const camera = new Camera(this.$refs.videoElement, {
                onFrame: async () => {
                    try{
                        await this.faceMesh?.send({image: this.$refs.videoElement});
                    } catch(e){
                        console.log(e)
                        this.log.push('frame error') // TODO cant work on ios
                        this.log.push(e)

                        this.stopCam()
                    }
                    if(this.isLoading){
                        this.isLoading = false;
                        this.$emit("doneLoading");
                        this.log.push('doneLoading')
                    }
                },
                width: window.innerWidth,
                height: window.innerHeight,
            });
            camera.start().then((stream) => {
                this.videoTracks = stream.getTracks();
                this.log.push('start')
            })

            this.$emit('mounted')
        } catch(e){
            console.log(e)
            this.log.push('mount error')
            this.log.push(e)
        }
    },
    beforeDestroy(){
        this.stopCam();
    }
}
</script>

<style scoped>
    .flip{
        transform: rotateY(180deg);
    }
</style>